import $ from 'jquery';

$('body').on('click', '.progress-stage__title', function () {
    const $this = $(this);
    const stage = $this.closest('.progress-stage');
    $('.progress-stage').removeClass('progress-stage--opened');
    stage.toggleClass('progress-stage--opened');
});

$(window).click((event) => {
    const target = $(event.target);
    if (!target.closest('.progress-stage').length) {
        $('.progress-stage').removeClass('progress-stage--opened');
    }
});
